import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThankYouLoginPageComponent } from '@shared/components';
import { RebalancingFormComponent } from './main/modules/services-and-repairs/pages/rebalancing-form/rebalancing-form.component';
import { NotfoundComponent } from './shared/components/notfound/notfound.component';
import { UnauthorizedPageComponent } from './shared/components/unauthorized-page/unauthorized-page.component';

const routes: Routes = [
	{
		path: 'page/:tenant',
		loadChildren: () => import('./main/main.module')
			.then(m => m.MainModule),
	},
	{
		path: 'thankyou',
		component: ThankYouLoginPageComponent
	},
	{
		path: 'unauthorized',
		component: UnauthorizedPageComponent,
	},
	{
		path: 'page/:tenant/rebalancing/:id',
		component: RebalancingFormComponent,
		pathMatch: 'full',
	},
	{
		path: '',
		redirectTo: 'page/mex',
		pathMatch: 'full'
	},
	{
		path: '**',
		component: NotfoundComponent,
		pathMatch: 'full'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
